<button *ngIf="product" (click)="suppliersModal = !suppliersModal" class="btn-text-icon btn btn-success">Supplier licenses <i class="pi pi-plus"></i></button>
<p-dialog header="Product Supplier" [modal]="true" [(visible)]="suppliersModal"
  [style]="{ width: '80%', height: '80%'}">
  <div class="taping">
    <button class="btn-text-icon {{ taping.globalSearch ? 'active' : '' }}"
      (click)="taping.globalSearch = true; taping.catalogs = false; taping.order = false; skuForm.reset()"><i
        class="pi pi-search"></i>
      Global Search</button>
    <button class="btn-text-icon {{ taping.catalogs ? 'active' : '' }}"
      (click)="taping.globalSearch = false; taping.catalogs = true; taping.order = false; skuForm.reset()"> <i
        class="pi pi-list"></i>
      Catalogs</button>
    <button class="btn-text-icon {{ taping.order ? 'active' : '' }}"
      (click)="taping.globalSearch = false; taping.catalogs = false; taping.order = true; suppliersTaping.bamboo = true; skuForm.reset(); createSupplierOrderForm('bamboo'); getAccounts('bamboo')">
      <i class="pi pi-plus-circle"></i>
      Order</button>
  </div>
  <form [formGroup]="skuForm">
    <div class="d-flex align-items-center justify-content-center gap-3 mb-3" *ngIf="!taping.order">
      <div class="icon-input">
        <input type="text" placeholder="Global Search" formControlName="searchKey">
        <i class="pi pi-search"
          (click)="taping.catalogs ? onVendorSelect({value: skuForm.get('supplier')?.value}) : vendorsSearch(skuForm.value)"></i>
      </div>
      <div class="icon-input">
        <input type="text" placeholder="Product Id" formControlName="code">
        <i class="pi pi-search"
          (click)="taping.catalogs ? onVendorSelect({value: skuForm.get('supplier')?.value}) : vendorsSearch(skuForm.value)"></i>
      </div>
    </div>
    @if (!taping.catalogs && !taping.order) {
    <!-- Best Price -->
    <div class="table suppliers best-price" *ngIf="vendorsSearchResult?.bestPrice?.price && !supplierLoader">
      <h4>Best Price</h4>
      <table class="mb-5">
        <thead>
          <th>Supplier Name</th>
          <th>Category Name</th>
          <th>S K U</th>
          <th>Product Name</th>
          <th>Price</th>
        </thead>
        <tbody>
          <tr
            (click)="chooseSupplier = vendorsSearchResult.bestPrice.vendor; addSkuModal = !addSkuModal; productSku = vendorsSearchResult.bestPrice.product.id; skuForm.get('supplier')?.setValue({name: vendorsSearchResult.bestPrice.vendor})">
            <td>{{ vendorsSearchResult.bestPrice.vendor }}</td>
            <td>{{ vendorsSearchResult.bestPrice.product.category.name }}</td>
            <td>{{ vendorsSearchResult.bestPrice.product.id }}</td>
            <td>{{ vendorsSearchResult.bestPrice.product.name }}</td>
            <td>{{ vendorsSearchResult.bestPrice.price| currency :
              vendorsSearchResult.bestPrice.product.pricing.currency }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Normal prices -->
    <div class="table suppliers" *ngIf="vendorsSearchResult && !supplierLoader">
      <table class="mb-4" *ngFor="let item of vendorsSearchResult.data">
        @if (item.products.length) {
        <thead>
          <th>Supplier Name</th>
          <th>Category Name</th>
          <th>S K U</th>
          <th>Product Name</th>
          <th>Price</th>
        </thead>
        <tbody>
          <tr *ngFor="let subitem of item.products"
            (click)="chooseSupplier = item.vendor; addSkuModal = !addSkuModal; productSku = subitem.id; skuForm.get('supplier')?.setValue(item.vendor); ">
            <td>{{ item.vendor }}</td>
            <td>{{ subitem.category.name }}</td>
            <td>{{ subitem.id }}</td>
            <td>{{ subitem.name }}</td>
            <td>{{ subitem.pricing.cost | currency : subitem.pricing.currency }}</td>
          </tr>
        </tbody>
        }
      </table>
    </div>

    } @else if ( !taping.globalSearch && !taping.order ) {
    <p-dropdown formControlName="supplier" [options]="suppliers.vendors" optionLabel="name" class="w-100"
      [showClear]="true" styleClass="w-100 mb-3" placeholder="Select a Supplier" (onChange)="onVendorSelect($event)"
      (onClear)="skuForm.reset()" *ngIf="!supplierLoader" />
    <div class="table suppliers" *ngIf="catalogsList.length && !supplierLoader">
      <table class="mb-4">
        <thead>
          <th>Supplier Name</th>
          <th>Category Name</th>
          <th>S K U</th>
          <th>Product Name</th>
          <th>Min & Max Price</th>
          <th>Price</th>
        </thead>
        <tbody>
          <tr *ngFor="let item of catalogsList" (click)="addSkuModal = !addSkuModal; productSku = item.id; chooseSupplier = skuForm.get('supplier')?.value?.name;">
            <td>{{ skuForm.get('supplier')?.value?.name }}</td>
            <td>{{ item.category.name }}</td>
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.pricing.min | currency : item.pricing.currency }} & {{ item.pricing.max | currency :
              item.pricing.currency }}</td>
            <td>{{ item.pricing.cost | currency : item.pricing.currency }}</td>
          </tr>
        </tbody>

      </table>
    </div>
    <p-paginator *ngIf="catalogsList?.length && !supplierLoader" (onPageChange)="onPageChange($event)" [first]="first"
      [rows]="limit" [currentPageReportTemplate]="page" [totalRecords]="total" [rowsPerPageOptions]="[10, 20, 30]" />

    }
    @if (!taping.order) {
      <!-- Alert Of Data Not Founded -->
      <h3 class="text-center mt-5" *ngIf="(!catalogsList.length || !vendorsSearchResult) && !supplierLoader ">
        There Is No Data</h3>
    }
    <!-- <button class="btn btn-dark btn-text-icon" [disabled]="skuForm.invalid" (click)="addSupplierSku()">{{ addingSku ?
    'Saving' : 'Save'}} <i class="pi pi-{{ addingSku ? 'spinner pi-spin' : 'bookmark' }}"></i></button> -->

    <!-- loader  -->
    <div class="loader position-relative w-100 h-100 d-flex align-items-center justify-content-center gap-4 fs-3 mt-5"
      *ngIf="supplierLoader">
      Loading Data<i class="pi pi-spin pi-spinner fs-3"></i>
    </div>
    <!-- Create Order -->
    <div *ngIf="taping.order">
      <div class="d-flex align-items-center justify-content-between gap-5">
        <!-- Supplier Taping -->
        <div class="taping w-25 me-auto mb-4">
          <button [disabled]="!GUIDChange" class="btn-text-icon {{ suppliersTaping.bamboo ? 'active' : '' }}"
            (click)="suppliersTaping.bamboo = true; suppliersTaping.likeCard = false; suppliersTaping.wupex = false; createSupplierOrderForm('bamboo'); getAccounts('bamboo')">
            Bamboo</button>
          <button [disabled]="!GUIDChange" class="btn-text-icon {{ suppliersTaping.likeCard ? 'active' : '' }}"
            (click)="suppliersTaping.bamboo = false; suppliersTaping.likeCard = true; suppliersTaping.wupex = false; createSupplierOrderForm('likeCard'); getAccounts('likecard')">
            LikeCard</button>
          <button [disabled]="!GUIDChange" class="btn-text-icon {{ suppliersTaping.wupex ? 'active' : '' }}"
            (click)="suppliersTaping.bamboo = false; suppliersTaping.likeCard = false; suppliersTaping.wupex = true; createSupplierOrderForm('wupex'); getAccounts('wupex')">Wupex</button>
        </div>
        <!-- Create Order - Change Request ID -->
        <div class="d-flex align-items-center gap-3">
          <button class="btn btn-{{GUIDChange ? 'success' : 'warning'}} btn-text-icon" [disabled]="GUIDChange"
          (click)="GUIDChange = !GUIDChange; enableForm(); generateGuid()">
          Change GUID <i class="pi pi-refresh"></i>
        </button>
        <button class="btn btn-primary btn-text-icon" [disabled]="formSupplierOrder.invalid" type="submit"
          (click)="createSupplierOrder(suppliersTaping.bamboo ? 'bamboo' : suppliersTaping.likeCard ? 'likecard' : suppliersTaping.wupex ? 'wupex' : '')">
          Send <i class="pi pi-arrow-right"></i>
        </button>
        </div>
      </div>
      <!-- Create Supplier Order Form  -->
      <form [formGroup]="formSupplierOrder">
        <div class="bamboo-form row" *ngIf="suppliersTaping.bamboo">
          <div class="form-group col-6">
            <label>Product ID <span class="p-error">*</span></label>
            <input type="text" placeholder="Product Id" class="form-control" formControlName="internalProductId" />
          </div>
          <div class="form-group col-6">
            <label class="d-block">Account ID <span class="p-error">*</span></label>
            <p-dropdown styleClass="w-100" [options]="accounts" [(ngModel)]="selectedAccount" optionLabel="id"
              [showClear]="true" formControlName="AccountId" placeholder="Select Account">
              <ng-template pTemplate="selectedItem">
                <div class="d-flex align-items-center gap-3">
                  <div><strong>Id : </strong> {{ selectedAccount.id }}</div>
                  <div><strong>Balance : </strong> {{ selectedAccount.balance | currency : selectedAccount.currency }}
                  </div>
                </div>
              </ng-template>
              <ng-template let-account pTemplate="item">
                <div class="d-flex align-items-center gap-3">
                  <div><strong>Id : </strong> {{ account?.id }}</div>
                  <div><strong>Balance : </strong> {{ account?.balance | currency : account?.currency }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="form-array  col-12 flex-grow-1" formArrayName="products">
            <div class="row" *ngFor="let item of productsFromArray.controls; let i = index;" [formGroupName]="i">
              <div class="form-group col-6">
                <label>Product SKU <span class="p-error">*</span></label>
                <input type="text" placeholder="Product SKU" class="form-control" formControlName="ProductId" />
              </div>
              <div class="form-group col-6">
                <label>Quantity <span class="p-error">*</span></label>
                <input type="number" placeholder="Quantity" class="form-control" formControlName="Quantity"
                  (keypress)="onlyNumbers($event)" />
              </div>
              <div class="form-group col-6">
                <label>Value <span class="p-error">*</span></label>
                <input type="number" placeholder="Value" class="form-control" formControlName="Value"
                  (keypress)="onlyNumbers($event)" />
              </div>
            </div>
          </div>
        </div>
        <!-- like card form -->
        <div class="likecard-form" *ngIf="suppliersTaping.likeCard">
          <div class="form-group">
            <label>Product ID <span class="p-error">*</span></label>
            <input type="text" placeholder="Product Id" class="form-control" formControlName="internalProductId" />
          </div>
          <div class="form-group">
            <label>Product SKU <span class="p-error">*</span></label>
            <input type="text" placeholder="Product Id" class="form-control" formControlName="productId" />
          </div>
          <div class="form-group">
            <label>Quantity <span class="p-error">*</span></label>
            <input type="number" placeholder="Product Id" class="form-control" formControlName="quantity" />
          </div>
        </div>
        <!-- wupex form -->
        <div class="wupex-form row" *ngIf="suppliersTaping.wupex">
          <div class="form-group col-6">
            <label>Product ID <span class="p-error">*</span></label>
            <input type="text" placeholder="Product Id" class="form-control" formControlName="internalProductId" />
          </div>
          <div class="form-array  col-6 flex-grow-1" formArrayName="products">
            <div class="row" *ngFor="let item of productsFromArray.controls; let i = index;" [formGroupName]="i">
              <div class="form-group col-12">
                <label>Product SKU <span class="p-error">*</span></label>
                <input type="text" placeholder="Product SKU" class="form-control" formControlName="sku" />
              </div>
              <div class="form-group col-12">
                <label>Quantity <span class="p-error">*</span></label>
                <input type="number" placeholder="Quantity" class="form-control" formControlName="quantity" />
              </div>

            </div>
          </div>
        </div>
      </form>
    </div>
  </form>

  <app-confirm-modal *ngIf="addSkuModal"
    (onConfirm)="addSupplierSku({chooseSupplier, id: productSku})"
    (onCancel)="addSkuModal = false" question="Are you sure you want to this SKU to this product ?"
    content="This action cannot be undone"></app-confirm-modal>
</p-dialog>